<div class="row py-4">
    <mat-checkbox required name="check" (change)="onChange($event.checked)" class="col-1">
    
    </mat-checkbox>
      <span class="col-11">
        {{ disClaimerText }}
      </span>
    <mat-error class="col-md-12 text-center" *ngIf="errorDisclaimer"> Debes aceptar los términos </mat-error>
</div>
  